export class JobCandidateStatus {
    id: number;
    description: string;

    private constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }

    public static New = new JobCandidateStatus(10, "New");
    public static Qualifying = new JobCandidateStatus(20, "Qualifying");
    public static Review = new JobCandidateStatus(25, "Review");
    public static Submitted = new JobCandidateStatus(30, "Submitted");
    public static Interviewing = new JobCandidateStatus(40, "Interviewing");
    public static Offered = new JobCandidateStatus(45, "Offered");
    public static Rejected = new JobCandidateStatus(50, "Rejected");
    public static Hired = new JobCandidateStatus(60, "Hired");

    public static asArray = () => {
        return [
            JobCandidateStatus.New,
            JobCandidateStatus.Qualifying,
            JobCandidateStatus.Review,
            JobCandidateStatus.Submitted,
            JobCandidateStatus.Interviewing,
            JobCandidateStatus.Offered,
            JobCandidateStatus.Rejected,
            JobCandidateStatus.Hired,
        ];
    };

    public static fromId = (id: number) => {
        if (id === undefined) return undefined;
        const status = JobCandidateStatus.asArray().find(s => s.id === id);
        return status;
    };
}
